var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"quill-editor"},[_vm._t("toolbar"),_vm._v(" "),_c('div',{ref:"editor"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }